import { Component, OnInit, ViewChild } from '@angular/core';//AfterViewInit,
import { Router } from '@angular/router'; //, NavigationExtras
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { saveAs } from 'file-saver';

// PROVIDER
import {BasicProvider} from '../providers/basic/basic';
import {UserProvider} from '../providers/user/user';
//import { CommonService } from '../providers/common.service';

import { AccountHeaderComponent }  from '../account-header/account-header.component';

@Component({
  selector: 'app-my-packages',
  templateUrl: './my-packages.component.html',
  styleUrls: ['./my-packages.component.css']
})
export class MyPackagesComponent implements OnInit {

  @ViewChild(AccountHeaderComponent)
  private acheader: AccountHeaderComponent;


  homedash = 'warehouse';
  //pakg_status ='Delivered';
  pakg_status ='Warehouse';
  search_key ='';
  next_date = '';
  next_id = '';
  pickedList:any;
  warehouselist:any;
  hDataMore = true;
  pDataMore = true;
  hNoRecordFound = false;
  pNoRecordFound = false;
  package_status_ary:any;
  showPopup : boolean = false;
  popClass = '';
  inProcess = false;
  hLastId = '';
  hNoData = false;
  pLastId = '';
  pNoData = false;
  showFilter = false;
  selector = '';

  constructor(
    public bp: BasicProvider,
    public up: UserProvider,
    public router: Router,
    public httpClient: HttpClient,
    //private CommonService: CommonService
  ) {
    this.getPackageList('',false);
  }

  ngOnInit() {
  }

  public applyFilter($event){
    this.search_key = $event;
    this.getPackageList('',false);
    console.log($event);
  }

  public resetFilter($event){
    this.search_key = $event;
    this.getPackageList('',false);
    console.log($event);
  }

  getPackageList( infiniteScroll : any = '', fromPaginate = false ){
    let api = 'warehouse/list';
		let searchFilter = {
      limit: 10,
      pakg_status: this.pakg_status,
      search_key : this.search_key,
      next_id: ''
    };

    if (this.pakg_status == 'Delivered') {
      if (fromPaginate) {
        searchFilter.next_id = this.pLastId;
      } else {
        this.pNoData = false;
      }

      if(this.pNoData){
        this.closeInfinete(infiniteScroll);
        return false;
      }
    } else {
      if (fromPaginate) {
        searchFilter.next_id = this.hLastId;
      } else {
        this.hNoData = false;
      }

      if(this.hNoData){
        this.closeInfinete(infiniteScroll);
        return false;
      }
    }

    //console.log(searchFilter);
    this.bp.hitApi(api, 'POST', searchFilter,true,true)
    .subscribe(
      (success) => {
        //console.log(success);
        if( success.type == true ){
          //success.data = [];
          this.manageListData(success,fromPaginate);
        }
        this.closeInfinete(infiniteScroll);
      },
      (error) => {
        this.manageListData('',fromPaginate);
        this.closeInfinete(infiniteScroll);
      }
    );

  }

  closeInfinete(obj){
    if(obj){
      //obj.complete();
    }
  }

  manageListData(data, fromPage){
    //console.log(data.package_status_ary);
    if(data.package_status_ary != ''){
      if(!this.package_status_ary){
        this.package_status_ary = data.package_status_ary;
        this.acheader.update_package_status(this.package_status_ary);
      }
    }

    if (this.pakg_status == 'Delivered') {
      this.acheader.showFilterButton(false);
      this.forPick(data, fromPage);
    } else {
      this.acheader.showFilterButton(true);
      this.forHouse(data, fromPage);
    }
    //console.log('warehoustlist',this.warehouselist);

  }

  forHouse(data, fromPage){
    var index = data.data.length-1;

    if(data.data != '' && data.data.length>0){
      this.hNoRecordFound = false;
      this.hLastId = data.data[index].id;
      //console.log(data.data.length);
      if(!fromPage){
        this.warehouselist = data.data;
      }
      else{
        this.warehouselist = this.warehouselist.concat(data.data);
      }
    }
    else{
      if(!fromPage){
        this.warehouselist = data.data;
        if(data.data.length == 0){
          this.hNoRecordFound = true;
        }
      }
      this.hNoData = true;
      console.log('No more data');
    }
  }

  forPick(data, fromPage){
    //pNoData
    var index = data.data.length-1;
    if(data.data != '' && data.data.length>0){
      this.pNoRecordFound = false;
      this.pLastId = data.data[index].id;
      if(!fromPage){
        this.pickedList = data.data;
      } else{
        this.pickedList = this.pickedList.concat(data.data);
      }
    } else {
      if (!fromPage) {
        if(data.data.length == 0){
          this.pNoRecordFound = true;
        }
      }
      this.pNoData = true;
      console.log('No more data');
    }
  }

  redirectNextPage(event, v, p){
    event.stopPropagation();
    if (v == 'd') {
      /*setTimeout(()=>{
        this.CommonService.sendData(p);
      },2000);*/
      this.up.tempWarehouseData = p;
      this.router.navigate(['addinvoive']);

    } else {
      this.router.navigate(['texdetail',p.id]);
    }

  }

  public beforeChange(tab_val: any) {

    if (tab_val=='picked') {

      this.pakg_status = 'Delivered';
    }else{
      this.pakg_status = 'Warehouse';
    }
    this.getPackageList('',false);
  }

  onScroll(infiniteScroll, fromPaginate = true ) {
    this.getPackageList( infiniteScroll, fromPaginate );
  }

  downloadFile(filename,e) {
    e.stopPropagation();
    let url = this.bp.httpUrl + 'warehouse/download_file';
    let body = {file_name:filename, folder:'receipts/'}
    return this.httpClient
    .post(url, body , {
      responseType : 'blob',
      headers : new HttpHeaders().append('content-type','application/json')
    })
    .subscribe(
      res => {
        //console.log(res.size);
        if (res.size > 0) {
          saveAs(res,filename);
        } else {
          this.bp.show_toast('Error','There is some error to download this file, please try later.');
        }

      }, error => {
        //console.log('download error:', JSON.stringify(error));
      }, () => {
        //console.log('Completed file download.')
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/my-packages/my-packages.component.ts